import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const AdminRoute = () => {
  const { user, isAuthenticated } = useAuth();


  if (!isAuthenticated || user?.role !== "admin") {
    return <Navigate to="/" replace />; 
  }

  return <Outlet />; 
};

export default AdminRoute;
